import script from "./modelStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./modelStatus.vue?vue&type=script&setup=true&lang=js"

import "./modelStatus.vue?vue&type=style&index=0&id=08fdd168&scoped=true&lang=less"

import exportComponent from "/home/jenkins/agent/workspace/web-project4knfj/booltool-lite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08fdd168"]])

export default __exports__